<template>
  <span class="input-textarea" :class="{'has-error': error}">
    <textarea
      ref="input"
      type="text"
      class="form-control"
      :class="inputClass"
      :style="inputStyle"
      :value="value"
      v-bind="$attrs"
      v-on="inputListeners"
    />
    <ErrorTooltip :target="$refs.input" v-bind="errorTooltipAttrs" />
  </span>
</template>

<script>
import InputMixin from './InputMixin'

export default {
  mixins: [
    InputMixin
  ],
  computed: {
    inputListeners: function() {
      return Object.assign({}, this.$listeners, {
        input: event => {
          this.$emit('input', event.target.value);
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.input-textarea {
  & textarea {
    width: 100%;
  }
  &.has-error textarea {
    background-color: #fdd;
    border: solid 1px red;
  }
}
</style>
